module.exports = __webpack_public_path__ + "img/result-error.37123ff5.png";